module.exports = __webpack_public_path__ + "img/bg.614da39f.jpg";